import React, {forwardRef} from "react";
import JsxParser from "react-jsx-parser";
import Button from "@/components/button";

export default forwardRef(({
  content,
  className = "",
}, ref) => {
  //replace double curly brace elements with JSX code
  let bodyString = content || "";

  while (bodyString.match(/\{\{.*?\}\}/)){
    let match = bodyString.match(/\{\{.*?\}\}/);
    let elementData = JSON.parse(match[0].slice(1, -1));
    let elementString = `<${elementData.name}`;
    for (let [key, value] of Object.entries(elementData)){
      if (key !== "name" && key !== "children"){
        elementString += ` ${key}="${value}"`;
      }
    }
    elementString += ">";
    if (elementData.children){
      elementString += elementData.children;
    }
    elementString += `</${elementData.name}>`;
    bodyString = bodyString.replace(match[0], elementString);
  }

  return <article className={`markdown ${className}`}>
    <JsxParser
      bindings={{
      }}
      autoCloseVoidElements
      components={{ Button }}
      jsx={bodyString}
    />
  </article>;
});
